
export const indianStates = [
    { name: "Andhra Pradesh", code: "37" },
    { name: "Arunachal Pradesh", code: "12" },
    { name: "Assam", code: "18" },
    { name: "Bihar", code: "10" },
    { name: "Chhattisgarh", code: "22" },
    { name: "Goa", code: "30" },
    { name: "Gujarat", code: "24" },
    { name: "Haryana", code: "06" },
    { name: "Himachal Pradesh", code: "02" },
    { name: "Jharkhand", code: "20" },
    { name: "Karnataka", code: "29" },
    { name: "Kerala", code: "32" },
    { name: "Madhya Pradesh", code: "23" },
    { name: "Maharashtra", code: "27" },
    { name: "Manipur", code: "14" },
    { name: "Meghalaya", code: "17" },
    { name: "Mizoram", code: "15" },
    { name: "Nagaland", code: "13" },
    { name: "Odisha", code: "21" },
    { name: "Punjab", code: "03" },
    { name: "Rajasthan", code: "08" },
    { name: "Sikkim", code: "11" },
    { name: "Tamil Nadu", code: "33" },
    { name: "Telangana", code: "36" },
    { name: "Tripura", code: "16" },
    { name: "Uttar Pradesh", code: "09" },
    { name: "Uttarakhand", code: "05" },
    { name: "West Bengal", code: "19" },
    { name: "Delhi", code: "07" },
    { name: "Jammu & Kashmir", code: "01" },
    { name: "Ladakh", code: "38" },
    { name: "Chandigarh", code: "04" },
    { name: "Andaman & Nicobar Islands", code: "35" },
    { name: "Dadra & Nagar Haveli and Daman & Diu", code: "26" },
    { name: "Lakshadweep", code: "31" },
    { name: "Puducherry", code: "34" },
];


export const initialValue = {
    serviceName: '',
    category: '',
    duration: '',
    price: '',
    serviceFor: '',
};

export const initialFormValidation = {
    serviceNameValidation: false,
    priceValidation: false,
    serviceForValidation: false,
};


export const serviceOptions = [
    {
        name: 'Male',
    },
    {
        name: 'Female',
    },
    {
        name: 'Both',
    },
];

export const initialProductValue = {
    productName: '',
    mrp: '',
    productCount: '',
    sellPrice: '',
};

export const initialFormProductValidation = {
    productNameValidation: false,
    mrpValidation: false,
    sellPriceValidation: false,
    productCountValidation: false,
};
